import { Obj } from "scrivito";
import { SchemaWidgetInstance } from "../SchemaWidgetClass";

const degreeMap: Record<string, string> = {
  bachelorOfArts: "Bachelor of Arts",
  bachelorOfScience: "Bachelor of Science",
  bachelorOfEngineering: "Bachelor of Engineering",
  masterOfScience: "Master of Science",
  masterOfArts: "Master of Arts",
  masterOfEngineering: "Master of Engineering",
  masterOfBusinessAdm: "Master of Business Administration",
};

function semesterToIsoDuration(semester: string | null): string | null {
  const n = parseInt(semester ?? "", 10);
  return Number.isNaN(n) ? null : `P${n}S`;
}

export const educationalOccupationalProgramJson = (
  data: SchemaWidgetInstance,
  page: Obj | null
) => {
  const isCoursePage = page?.objClass() === "CoursePage";

  const name = data.get("name") || (isCoursePage ? page?.get("title") : null);
  const description =
    data.get("description") ||
    (isCoursePage ? page?.get("courseDescription") : null);
  const url =
    data.get("url") ||
    (isCoursePage && page ? `https://www.hs-heilbronn.de${page.path()}` : null);

  const degreeKey = isCoursePage ? (page?.get("degree") as string) : null;
  const credential =
    data.get("educationalCredentialAwarded") ||
    (degreeKey ? degreeMap[degreeKey] ?? degreeKey : null);

  const creditsRaw = isCoursePage ? (page?.get("credits") as string) : null;
  const numberOfCredits =
    data.get("numberOfCredits") ||
    (creditsRaw ? parseInt(creditsRaw, 10) : null);

  const semesterRaw = isCoursePage ? (page?.get("semester") as string) : null;
  const timeToComplete =
    data.get("timeToComplete") || semesterToIsoDuration(semesterRaw);

  const deadlineValues = isCoursePage
    ? [
        ...((page?.get("deadline") as string[]) ?? []),
        ...((page?.get("customDeadline") as string[]) ?? []),
      ].join(", ") || null
    : null;
  const applicationDeadline = data.get("applicationDeadline") || deadlineValues;

  const prerequisites = data.get("programPrerequisites");

  return {
    "@context": "https://schema.org",
    "@type": "EducationalOccupationalProgram",
    name,
    description,
    url,
    educationalCredentialAwarded: credential,
    numberOfCredits: numberOfCredits ?? undefined,
    timeToComplete: timeToComplete ?? undefined,
    applicationDeadline: applicationDeadline ?? undefined,
    programPrerequisites: prerequisites ?? undefined,
    provider: {
      "@type": "CollegeOrUniversity",
      name: "Hochschule Heilbronn",
      url: "https://www.hs-heilbronn.de",
    },
  };
};
